import script from "./BaseCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=1f7e9e0a&lang=scss&scoped=true"
script.__scopeId = "data-v-1f7e9e0a"

export default script